import { RefreshResponse } from '@triare/auth-redux/src/saga/auth';
import {
  DefaultFetchError, FetchCreate, useFetchCreate,
} from '../fetch';
import { State2FAParams, User, UserStatusType } from '../../store/auth';

export interface AdminCreateParams extends Pick<User, | 'role' | 'email' | 'firstName' | 'lastName'> {
  password: string; // Only for create. on update it's removed
  status?: UserStatusType;
}

export const useAdminCreate = (): FetchCreate<User, DefaultFetchError, AdminCreateParams> => (
  useFetchCreate('admins')
);

export interface AdminUpdateParams extends Omit<Partial<AdminCreateParams>, 'password'> {
  isTwoFAActive?: boolean;
}

/** Otp: */
export interface VerifyTotpPayload {
  code: string;
}

export const useAdminVerifyOtp = (): FetchCreate<
  RefreshResponse | State2FAParams, DefaultFetchError, VerifyTotpPayload> => (
  useFetchCreate('auth/admin/verify-totp')
);
